import React from 'react'

const FooterSectionThree = () => {
    return (
        <>
            <h3 className="footer-title">Information</h3>
            <ul className="footer-menu-list">
                <li>
                    <a href="#">Find a Store</a>
                </li>
                <li>
                    <a href="#">About Us</a>
                </li>
                <li>
                    <a href="#">Contact Us</a>
                </li>
                <li>
                    <a href="#">Delivery information</a>
                </li>
                <li>
                    <a href="#">Privacy Policy</a>
                </li>
                <li>
                    <a href="#">Terms &amp; Conditions</a>
                </li>
                <li>
                    <a href="#">Gift Cards</a>
                </li>
            </ul>
        </>
    )
}

export default FooterSectionThree